export const FORGOT_PASSWORD_INIT_ACTION = "FORGOT_PASSWORD_INIT_ACTION";
export const FORGOT_PASSWORD_SUCCESS_ACTION =
  FORGOT_PASSWORD_INIT_ACTION + "_SUCCESS";
export const FORGOT_PASSWORD_FAIL_ACTION =
  FORGOT_PASSWORD_INIT_ACTION + "_ERROR";
